import { SET_HAPPENING, SET_STORE_AVAILABILITIES } from 'constants/actionTypes/happening';

const initialState = {
    storeAvailabilities: []
};

const reducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_HAPPENING: {
            return {
                ...state,
                ...payload?.data
            };
        }

        case SET_STORE_AVAILABILITIES: {
            return {
                ...state,
                storeAvailabilities: payload.data
            };
        }

        default: {
            return state;
        }
    }
};

export default reducer;
